import React from 'react';

import { BlockquoteBlockData } from 'api/cms';
import Box from 'components/Box';
import { Body, BodyLarge, RichText } from 'components/Text';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const BlockquoteBlock = ({
  data: { quote, cite },
}: {
  data: BlockquoteBlockData;
}) => (
  <RichText>
    <Box component="blockquote">
      <BodyLarge
        dangerouslySetInnerHTML={{
          __html: quote,
        }}
      />
      {cite && (
        <Box mt="18px">
          <Body>{cite}</Body>
        </Box>
      )}
    </Box>
  </RichText>
);

// eslint-disable-next-line import/no-default-export
export default BlockquoteBlock;
